<template>
    <a-drawer
        :title="$t('program.repeat_list_drawer_title' /* 日程自动查重 */)"
        width="85%"
        placement="right"
        :closable="true"
        :body-style="{ height: 'calc(100vh - 57px)', overflow: 'auto' }"
        :visible="visible"
        @close="visible = false"
    >
        <h2 class="mt5 fs14">{{ $t('program.repeat_list_drawer_date_conflict_title' /* 日程时间冲突 */) }}</h2>
        <!--    表格    -->
        <a-table :pagination="false" :rowKey="record => record.program_id" :columns="dateColumns" :data-source="dataDateList" class="mt15" size="middle" :scroll="{ x: 1400 }">
            <template slot="starttime_slot" slot-scope="text, record">
                <span v-if="record.starttime_slot">{{ record.starttime_slot }}-{{ record.endtime_slot }}</span>
            </template>
            <template slot="title_slot" slot-scope="text, record">
                <p class="mb5" v-if="record.class_cnname">[{{ record.class_cnname }}]</p>
                <p class="mb5" v-if="record.abstract_title">{{ record.abstract_title }}</p>
            </template>
            <template slot="action" slot-scope="text, record">
                <a-button type="link" @click="$refs.childSessionDrawerRef.show(record, sessionList[record.hall_id][record.date_id])">
                    {{ $t('program.repeat_list_drawer_edit_unit' /* 单元编辑 */) }}
                </a-button>
            </template>
        </a-table>
        <h2 class="mt15 fs14">{{ $t('program.repeat_list_drawer_fayan_conflict_title' /* 同一篇论文多次发言 */) }}</h2>
        <a-table :pagination="false" :rowKey="record => record.program_id" :columns="fayanColumns" :data-source="dataFayanList" class="mt15" size="middle" :scroll="{ x: 1400 }">
            <template slot="starttime_slot" slot-scope="text, record">
                <span v-if="record.starttime_slot">{{ record.starttime_slot }}-{{ record.endtime_slot }}</span>
            </template>
            <template slot="title_slot" slot-scope="text, record">
                <p class="mb5" v-if="record.class_cnname">[{{ record.class_cnname }}]</p>
                <p class="mb5" v-if="record.abstract_title">{{ record.abstract_title }}</p>
            </template>
            <template slot="all_slot" slot-scope="text, record">
                <p class="mb5" v-for="(it, idx) in record.all" :key="idx">{{ it }}</p>
            </template>
        </a-table>

        <!-- <childSessionDrawer ref="childSessionDrawerRef" /> -->
        <childSessionDrawer
            ref="childSessionDrawerRef"
            @open-sub-session="handleOpenSubSession"
            :dateList="dateList"
            :hallList="hallList"
            :xuezuList="xuezuList"
            :title="$t('program.child_session_management' /* 会议日程管理 */)"
        />
        <!-- 子session - 用于递归弹出 -->
        <childSessionDrawer
            ref="subChildSessionDrawerRef"
            @open-sub-session="handleOpenSubSession"
            :dateList="dateList"
            :hallList="hallList"
            :xuezuList="xuezuList"
            :title="$t('program.child_session_management' /* 子日程管理 */)"
            :is-sub="true"
        />
    </a-drawer>
</template>

<script>
import childSessionDrawer from './child-session-drawer.vue';
export default {
    name: 'repeatListDrawer',
    components: { childSessionDrawer },
    props: {
        xuezuList: {
            type: Array,
            default: function () {
                return [];
            }
        },
        dateList: {
            type: Array,
            default: function () {
                return [];
            }
        },
        hallList: {
            type: Array,
            default: function () {
                return [];
            }
        }
    },
    data() {
        return {
            visible: false,
            dataDateList: [], // 日程时间冲突列表
            dataFayanList: [], // 同一篇论文多次发言
            dateColumns: [
                {
                    title: this.$t('web.name' /* 姓名 */),
                    dataIndex: 'real_name',
                    width: 100,
                    fixed: 'left'
                },
                {
                    title: this.$t('web.company' /* 单位 */),
                    dataIndex: 'org_cnname',
                    width: 200
                },
                {
                    title: this.$t('web.date' /* 日期 */),
                    dataIndex: 'meeting_date',
                    width: 100
                },
                {
                    title: this.$t('web.time' /* 时间 */),
                    dataIndex: 'starttime_slot',
                    scopedSlots: { customRender: 'starttime_slot' },
                    width: 100
                },
                {
                    title: this.$t('program.batch_live_label_hall' /* 会场 */),
                    dataIndex: 'meeting_hall'
                },
                {
                    title: this.$t('program.batch_live_label_xuezu' /* 专题分论坛 */),
                    dataIndex: 'class_cnname'
                },
                {
                    title: 'Session',
                    dataIndex: 'ptitle'
                },
                {
                    title: this.$t('program.task' /* 任务 */),
                    dataIndex: 'typename_cn'
                },
                {
                    title: this.$t('program.theme' /* 主题 */),
                    dataIndex: 'title_slot',
                    scopedSlots: { customRender: 'title_slot' }
                },
                {
                    title: this.$t('web.actions' /* 操作 */),
                    dataIndex: 'action',
                    align: 'center',
                    scopedSlots: { customRender: 'action' },
                    width: 100,
                    fixed: 'right'
                }
            ],
            fayanColumns: [
                {
                    title: this.$t('program.abstract_id' /* 论文ID */),
                    dataIndex: 'number',
                    width: 100,
                    fixed: 'left'
                },
                {
                    title: this.$t('web.date' /* 日期 */),
                    dataIndex: 'meeting_date',
                    width: 100
                },
                {
                    title: this.$t('web.time' /* 时间 */),
                    dataIndex: 'starttime_slot',
                    scopedSlots: { customRender: 'starttime_slot' },
                    width: 100
                },
                {
                    title: this.$t('program.batch_live_label_hall' /* 会场 */),
                    dataIndex: 'meeting_hall'
                },
                {
                    title: this.$t('program.batch_live_label_xuezu' /* 专题分论坛 */),
                    dataIndex: 'class_cnname',
                    width: 100
                },
                {
                    title: this.$t('program.unit' /* 单元 */),
                    dataIndex: 'ptitle',
                    width: 100
                },
                {
                    title: this.$t('program.type' /* 类型 */),
                    dataIndex: 'typename_cnp',
                    width: 100
                },
                {
                    title: this.$t('program.question' /* 题目 */),
                    dataIndex: 'title_slot',
                    scopedSlots: { customRender: 'title_slot' }
                },
                {
                    title: this.$t('program.task_allocation' /* 任务分配 */),
                    dataIndex: 'all',
                    scopedSlots: { customRender: 'all_slot' }
                }
            ],
            sessionList: []
        };
    },
    computed: {},
    methods: {
        show(programList) {
            this.visible = true;
            this.sessionList = programList;
        },
        getDateList() {
            // , headers: { meetingID: 1111 }
            this.$request.get({ url: 'getRepeatDateTime' }).then(res => {
                this.dataDateList = res.data.list;
            });
        },
        getFayanList() {
            // , headers: { meetingID: 1111 }
            this.$request.get({ url: 'getRepeatFayan' }).then(res => {
                this.dataFayanList = res.data.list;
            });
        },
        /**
         * 处理子日程弹出事件
         */
        handleOpenSubSession(record, sessionList) {
            // 使用新的抽屉实例，保持当前抽屉打开
            this.$refs.subChildSessionDrawerRef.show(record, sessionList);
        }
    },
    created() {},
    mounted() {
        this.getDateList();
        this.getFayanList();
    }
};
</script>
<style lang="less" scoped></style>
